import React, { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../../hooks";
import { VirtualScenes } from "../../../../api";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./Module6.scss";

const virtualScenesController = new VirtualScenes();

export function Module6({ refId }) {
  const module6 = "module_06";
  const { accessToken } = useAuth();

  const [moduleData, setModuleData] = useState(null);
  const [additionalImages, setAdditionalImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchModuleData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await virtualScenesController.getVirtualScenesModeule(
        refId,
        accessToken,
        module6
      );
      setModuleData(data.moduleData);

      if (data.moduleData?.ModSixAdditionalMaterials?.length) {
        const imagePromises = data.moduleData.ModSixAdditionalMaterials.map(
          async (id) => {
            const imageData = await virtualScenesController.getRepoScene(
              id,
              accessToken
            );
            return imageData;
          }
        );
        const imagesDataArray = await Promise.all(imagePromises);
        setAdditionalImages(imagesDataArray);
      }
    } catch (err) {
      console.error("Error al obtener datos del módulo:", err);
      setError("Error al cargar el módulo");
    } finally {
      setLoading(false);
    }
  }, [refId, accessToken, module6]);

  useEffect(() => {
    if (refId && accessToken) {
      fetchModuleData();
    }
  }, [refId, accessToken, fetchModuleData]);

  if (loading) return <div></div>;
  if (error) return <div>{error}</div>;

  const sources = moduleData?.ModSixFuentes;

  return (
    <div className="module6-container">
      <h2 className="block-title">MATERIAL ADICIONAL</h2>
      <div className="module6-carousel">
        {additionalImages.length > 0 ? (
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 10000 }}
            loop={true}
          >
            {additionalImages.map((item, index) => (
              <SwiperSlide key={index}>
                <img
                  src={item.url}
                  alt={item.title || `Material adicional ${index + 1}`} // Usar item.title o un fallback descriptivo
                  className="module6-carousel-image"
                />
                {item.title && <p className="image-title">{item.title}</p>}
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="image-placeholder">No hay imágenes disponibles</div>
        )}
      </div>

      {sources && sources.trim() !== "" && (
        <p className="module6-sources">
          Fuentes: {sources}
        </p>
      )}
    </div>
  );
}